
import React from "react";
import { useNavigate } from "react-router-dom";
import AppFooter from "./AppFooter";
import { FaArrowLeft } from "react-icons/fa";

function PrivacyPolicy() {
  const navigate = useNavigate();
  const globalStyle = {
    fontFamily: 'Arial, sans-serif',
    color: '#000',
  };

  return (
    <>
      {/* Desktop inline action bar (replaces footer on desktop) */}
      <div className="desktop-action-bar">
        <button type="button" onClick={() => navigate(-1)}>
          <FaArrowLeft /> Back
        </button>
      </div>

      <div
        className="privacy-policy-container"
        style={{
          padding: "2rem",
          maxWidth: "800px",
          margin: "0 auto",
          paddingBottom: "5rem", // extra space for fixed footer
          color: "#000",
          background: "#fff",
          globalStyle,
        }}
      >
        <h1 className="hdr hdr--primary hdr--lg">Privacy Policy</h1>
        <p>
          <strong>Effective Date:</strong> January 1, 2025
        </p>

        <p>
          On-Screen (“we”, “our”, or “us”) operates the On-Screen Web App (the
          “Service”). This page informs you of our policies regarding the
          collection, use, and disclosure of personal information when you use
          our Service.
        </p>

        <p>
          By using the Service, you agree to the collection and use of
          information in accordance with this policy.
        </p>

        <h2>1. Information We Collect</h2>

        <h3>Personal Information</h3>
        <p>
          We may ask you to provide certain personally identifiable information,
          including but not limited to:
        </p>
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Username</li>
          <li>Social media accounts (e.g., Twitter, Instagram, Threads, Facebook, TikTok, LinkedIn)</li>
        </ul>

        <h3>Usage Data</h3>
        <p>We may collect information such as:</p>
        <ul>
          <li>Device and browser type</li>
          <li>Pages visited and time spent</li>
          <li>IP address</li>
        </ul>

        <h3>Cookies and Tracking</h3>
        <p>
          We use cookies and similar tracking technologies to monitor activity
          and store information.
        </p>

        <h2>2. How We Use Your Information</h2>
        <p>We use the collected information to:</p>
        <ul>
          <li>Operate and maintain the Service</li>
          <li>Authenticate users</li>
          <li>Personalize your experience</li>
          <li>Communicate updates and support</li>
          <li>Enable social integrations and posting</li>
          <li>Detect and prevent abuse</li>
        </ul>

        <h2>3. Sharing Your Information</h2>
        <p>We do not sell your data. We may share it:</p>
        <ul>
          <li>With service providers helping operate the app</li>
          <li>To comply with legal obligations</li>
          <li>To protect our rights and property</li>
          <li>With your explicit consent</li>
        </ul>

        <h2>4. Data Retention</h2>
        <p>
          We retain personal data only as long as necessary. You can request data
          deletion by contacting us at info@on-screen.app.
        </p>

        <h2>5. Security</h2>
        <p>
          We use reasonable measures to protect your data, but no method is 100%
          secure.
        </p>

        <h2>6. Your Data Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access, update, or delete your information</li>
          <li>Withdraw consent for data processing</li>
          <li>Request a copy of your data</li>
        </ul>

        <h2>7. Third-Party Services</h2>
        <p>
          Our app integrates with third-party social media services including
          Instagram, Facebook, Threads (by Meta), Twitter/X, TikTok, LinkedIn,
          YouTube, Bluesky, and Pinterest. We are not responsible for their
          privacy practices. Each platform's own privacy policy governs data on
          their servers.
        </p>

        <h3>7a. Threads (by Meta) — Data Usage Disclosure</h3>
        <p>When you connect your Threads account to On-Screen, we access and store the following data via the Threads API:</p>
        <ul>
          <li><strong>Profile information:</strong> Threads user ID, username, and profile picture URL (used to identify your connected account)</li>
          <li><strong>Content publishing:</strong> We publish text posts, images, videos, and carousels to Threads on your behalf when you use our post composer or scheduler</li>
          <li><strong>Replies and conversations:</strong> We read replies to your posts and display them in our reply management interface. We can post replies and hide/unhide replies on your behalf</li>
          <li><strong>Insights and analytics:</strong> We fetch post-level metrics (views, likes, replies, reposts, quotes) and account-level insights (follower count) to display in our analytics dashboard</li>
        </ul>
        <p><strong>Data storage and retention:</strong> Threads OAuth tokens are stored per-tenant in our database and are used solely to perform the actions described above. Tokens are automatically deleted when you disconnect Threads from your Integrations page, or when Meta sends a deauthorization callback.</p>
        <p><strong>Data deletion:</strong> You can disconnect Threads at any time from the Integrations page, which removes all stored Threads credentials. Meta's data deletion callback automatically removes all Threads data associated with your account. You may also contact us at <strong>info@on-screen.app</strong> to request manual deletion.</p>

        <h2>8. Children’s Privacy</h2>
        <p>
          Our Service is not intended for children under 13. We do not knowingly
          collect data from minors.
        </p>

        <h2>9. Requests from Public Authorities</h2>
        <p>
          On-Screen is a multi-tenant SaaS used by businesses (“tenants”) to
          connect social accounts (via Integrations → Connected Accounts),
          create/schedule posts, and manage engagement in a Moderation Inbox,
          with de-identified/aggregated Analytics.
          <br />
          <br />
          Valid legal process required. We respond only to properly served legal
          process (e.g., subpoena, court order, or warrant) or a legally
          supported emergency request.
          <br />
          <br />
          Legal review &amp; challenge. A designated compliance owner (with
          outside counsel as needed) reviews each request. We challenge unlawful,
          overbroad, or unclear demands and seek to narrow scope.
          <br />
          <br />
          Data minimization. If disclosure is legally required, we limit
          production to the least amount of information necessary, typically:
          <br />
          <br />
          identifiers and tokens tied to connected assets (e.g., Page/IG account
          IDs stored in Integrations),
          <br />
          <br />
          interaction content/metadata already visible to tenant admins in
          Moderation Inbox (e.g., comments/messages for moderation),
          <br />
          <br />
          system logs strictly needed to fulfill the order, and
          <br />
          <br />
          aggregated Analytics remain aggregated; we do not disclose
          de-identified metrics in a way that can be re-identified.
          <br />
          <br />
          Tenant notice. Where allowed by law and not an emergency, we notify the
          affected tenant admin prior to disclosure to enable their own rights
          and remedies.
          <br />
          <br />
          Documentation &amp; security. We keep an internal record of the
          requesting authority, legal basis, scope, dates, our analysis, and data
          actually produced. Transfers use secure channels; we do not grant live
          or back-door access.
          <br />
          <br />
          Retention &amp; deletion. We retain only as long as necessary to comply
          with the request and applicable law. Disconnecting accounts in
          Integrations or tenant-initiated deletion/removal requests are honored
          per our data retention schedule.
          <br />
          <br />
          Contact. Public authorities may reach us at info@on-screen.app. Service
          of process is not accepted by email; a physical address for service is
          available upon request.
        </p>

        <h2>10. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy periodically. Any changes will be
          posted here with an updated effective date.
        </p>

        <h2>11. Contact Us</h2>
        <p>
          If you have any questions, please contact us at:{" "}
          <strong>info@on-screen.app</strong>
        </p>
        <p>
          To request deletion of your personal data, please contact us at :{" "}
          <strong>info@on-screen.app</strong> with the subject “Data Deletion
          Request” and include your registered email address.
        </p>
      </div>

      <AppFooter
        buttons={[
          {
            icon: <FaArrowLeft />,
            label: "Back",
            onClick: () => navigate(-1),
          },
        ]}
      />
    </>
  );
}

export default PrivacyPolicy;
